import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ErrorTranslations } from 'src/config/labels/errorTranslations';
import { PartnerPositions } from 'src/config/labels/partnerPositions';
import { InitialPartnerModelRequestModel } from 'src/models/requestModels/V2/partner/InitialPartnerModelRequestModel';
import { LocalstorageserviceService } from 'src/services/infrastructureServices/localstorageservice/localstorageservice.service';
import { RegistrationService } from 'src/services/requestServices/V2/registration/registration.service';
import { UserinfostoreService } from 'src/services/stateServices/userinfoservice/userregistrationstateservice.service';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-emailconfirmation',
  templateUrl: './emailconfirmation.component.html',
  styleUrls: ['./emailconfirmation.component.css']
})
export class EmailconfirmationComponent extends BaseComponent implements OnInit {

  public requestCompleted = false;
  public requestFailed = false;
  public requestErrorMessage = '';

  constructor(protected userinfostoreService : UserinfostoreService,
              protected localStorageService : LocalstorageserviceService,
              protected router: Router,
              private activatedRoute: ActivatedRoute,
              private registrationService: RegistrationService,
              private toastr: ToastrService) {
    super(userinfostoreService, localStorageService, router)
    this.nextPage = 'registration/password/change';
    this.backPage = 'registration/email';
    this.pageName = 'emailConfirmationPage';
  }

  ngOnInit(): void {
    if (!this.user || !this.user.email) {
      this.router.navigate(['registration/email']);
      return;
    }

    let partnerType = '';
    if (this.user.shareholder && this.user.owner) {
      partnerType = PartnerPositions.positions.both;
    }
    else if (this.user.shareholder) {
      partnerType = PartnerPositions.positions.shareholder
    }
    else {
      partnerType = PartnerPositions.positions.owner
    }
    const beginRegistrationRequestModel: InitialPartnerModelRequestModel = {
      email: this.user.email,
      partner_type: partnerType
    }
    this.registrationService.initiateRegistration(beginRegistrationRequestModel).subscribe(() => {
      this.requestCompleted = true;
      this.requestFailed = false;
    }, (error: HttpErrorResponse) => {
      this.handleRegistrationRequestError(error);
    })
  }

  private handleRegistrationRequestError(error?: HttpErrorResponse): void {
    const backendMessage = error && error.error && error.error.message;
    const translatedBackendMessage = backendMessage ? ErrorTranslations.translate(backendMessage, this.language) : '';
    this.requestCompleted = true;
    this.requestFailed = true;
    this.requestErrorMessage = translatedBackendMessage || this.lables(this.getPageName()).error;
  }

}
